import AclMixin from '@/components/acl/acl-mixin';
import Api from '@/services';
import BemobApi from '@/services/rest/bemob';
const bemobApi: BemobApi = new BemobApi();
import store from '@/store';

export default async (to: any, from: any, next: Function) => {
  const { authToken, isProfileLoaded } = store.state;
  if (authToken) {
    if(!isProfileLoaded){
      await bemobApi.loadProfileData();
    }

    const notAllowedCondition = to.meta && to.meta.aclRules && !AclMixin.canAccessPage(to.meta.aclRules);
    const notFoundCondition = to?.meta?.notFound;

    const { user } = store.state;
    const isEmailVerificationRequired = !user?.emailVerified;
    const isCurrencyRequired = !user?.currencyId;

    if(isEmailVerificationRequired){
      if(from?.name === 'register-email-verification'){
        return next(false);
      }else{
        return next({ name: 'register-email-verification'});
      }
    }

    if(isCurrencyRequired){
      if(from?.name === 'register-currency'){
        return next(false);
      }else{
        return next({ name: 'register-currency'});
      }
    }

    if(notAllowedCondition || notFoundCondition) {
      return next(Api.getDashboardLink(store.state.user))
    } else {
      return next();
    }

  }

  return next({ path: '/login', query: { redirect: to.fullPath } });
};
